import {
    FETCH_DISCOUNTS,
    FETCH_DISCOUNTS_FAILURE,
    FETCH_DISCOUNTS_SUCCESS,
    FETCH_DISCOUNT,
    FETCH_DISCOUNT_FAILURE,
    FETCH_DISCOUNT_SUCCESS,
} from 'store/actions/types';
import utils from 'helpers/utils';

export const fetchDiscounts = (payload) => {
    payload = payload || {};

    let params = {
        size: payload.size ? payload.size : 12,
        sort_by: payload.field ? payload.field : 'id',
        sort_direction: payload.order ? payload.order.toLowerCase() : 'asc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    if (!utils.isEmpty(payload.filter)) {
        const filters = utils.buildFilterObject(payload.filter);

        params = Object.assign({}, params, filters);
    }

    return {
        type: FETCH_DISCOUNTS,
        payload: params,
    };
};

export const fetchDiscountsFailure = (error) => {
    return {
        type: FETCH_DISCOUNTS_FAILURE,
        error: error,
    };
};

export const fetchDiscountsSuccess = (payload) => {
    return {
        type: FETCH_DISCOUNTS_SUCCESS,
        payload: payload,
    };
};

export const fetchDiscount = (payload) => {
    return {
        type: FETCH_DISCOUNT,
        payload: payload,
    };
};

export const fetchDiscountFailure = (error) => {
    return {
        type: FETCH_DISCOUNT_FAILURE,
        error: error,
    };
};

export const fetchDiscountSuccess = (response) => {
    return {
        type: FETCH_DISCOUNT_SUCCESS,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discounts/fetchDiscounts.js